import { jsx as _jsx } from "react/jsx-runtime";
import { signinRedirect } from '../../apis';
import { Spin } from 'antd';
import { useEffect } from 'react';
export function SignoutOidcCallback() {
    useEffect(() => {
        async function signinAsync() {
            await signinRedirect();
        }
        signinAsync();
    }, []);
    return (_jsx("div", { style: { textAlign: 'center', marginTop: '20px' }, children: _jsx(Spin, { size: 'large' }) }));
}
